module.exports = __webpack_public_path__ + "static/daddymug-5dd830aea47835ffecb5994d059ace14.jpeg";